import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "../actions/loginAction";
import { SET_EMAIL, SET_PASSWORD } from "../types";
import styles from "../assets/css/LoginPage.module.css";

const LoginPage = () => {
  const { username, password, token } = useSelector(
    (state) => state.loginReducer
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUsernameChanged = (value) => {
    dispatch({
      type: SET_EMAIL,
      payload: value,
    });
  };

  const handlePasswordChanged = (value) => {
    dispatch({
      type: SET_PASSWORD,
      payload: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      username,
      password,
    };
    dispatch(loginAction(body));
  };

  useEffect(() => {
    if (token || localStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate, token]);

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.container}>
        <div className={styles.text1}>Добро пожаловать!</div>
        <div className={styles.box1}>
          <input
            className={styles.email}
            onChange={(e) => handleUsernameChanged(e.target.value)}
            placeholder="Login"
            type="text"
            value={username}
          />
          <input
            className={styles.password}
            onChange={(e) => handlePasswordChanged(e.target.value)}
            placeholder="Пароль"
            type="password"
            value={password}
          />
          <button type="submit" className={styles.button}>
            Войти
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoginPage;
